import { Table } from 'antd';
import { TableProps } from 'antd/lib/table';
import Column from 'antd/lib/table/Column';
import React from 'react';

type NumberedTableType = <RecordType extends object = any>(
  props: TableProps<RecordType>
) => JSX.Element;

export const NumberedTable: NumberedTableType = (props) => {
  return (
    <Table {...props}>
      <Column
        title="#"
        width={15}
        key="index"
        render={(text, record, index) => {
          return (
            <>
              {props.pagination && props.pagination.current
                ? (props.pagination.current - 1) *
                    (props as any).pagination.pageSize +
                  (index + 1)
                : index + 1}
            </>
          );
        }}
      />
      {props.children}
    </Table>
  );
};
